<template>
    <div :id="`store-locator-card-${object.id}`">
        <div class="card store-locator-card">
            <router-link :to="mainActionUrl" @click.native="sendGaClickEvent()">
                <img
                    class="card-img-top"
                    :src="`/images/states/${getStateShortName.toLowerCase()}.svg`"
                    :alt="`${object.name} Best Jewelry Stores - ${object && object.shortName ? object.shortName : ''} Best Jewelry Stores`" />
            </router-link>
            <div class="card-body">
                <div class="card-headline">
                    <router-link :to="mainActionUrl" @click.native="sendGaClickEvent()">
                        <h3
                            class="card-title"
                            :itemtype="getItemType"
                            :class="{
                                'title-only': $route.name !== 'find-a-jeweler-by-state' && (!object.cities || !object.cities.length),
                            }">
                            {{ object.name }}
                        </h3>
                    </router-link>
                    <span class="expand-btn" @click="showCities = !showCities">{{ showCities ? "-" : "+" }}</span>
                </div>
                <div v-show="showCities">
                    <div v-if="object.cities && object.cities.length">
                        <ul class="list-unstyled">
                            <li v-for="(city, index) in cities" :key="index" v-if="city && city.name && (showSeoCities || city.storesCount > 0)">
                                <router-link
                                    class="btn btn-link card-link-btn"
                                    :to="`/jewelry-stores/${object.shortName.toLowerCase()}/${city.name.replace(/\s+/g, '-').toLowerCase()}`"
                                    @click.native="sendGaClickEvent(city)">
                                    <h4 itemtype="https://schema.org/City">{{ city.name }}</h4>
                                </router-link>
                            </li>
                        </ul>
                        <!-- <button v-if="object.cities.length > 50" aria-label="see more" class="btn btn-link card-link-btn show-btn" @click.native="showMore">
                        <span>SEE MORE</span>
                        <img alt="+" src="../../../../assets/images/icons/plus.svg" class="float-right">
                    </button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "store-locator-card",
    props: ["object", "showSeoCities"],
    data() {
        return {
            showCities: false,
            maxCitiesToShow: 50,
            currentLoadedPage: "state",
        };
    },
    computed: {
        mainActionUrl() {
            switch (this.$route.name) {
                case "find-a-jeweler-by-state":
                    return `/jewelry-stores/${this.object.shortName.toLowerCase()}`;
                case "find-a-jeweler-by-city":
                    return `${this.$route.path}/${this.object.name.replace(/\s+/g, "-").toLowerCase()}`;
                case "specialities":
                    return "/";
                default:
                    return "/";
            }
        },
        getItemType() {
            return `https://schema.org/${this.object && this.object.cities ? `State` : `City`}`;
        },
        cities() {
            return this.object && this.object.cities && this.object.cities.length ? this.object.cities : [];
        },
        getStateShortName() {
            return this.$route.params && this.$route.params.stateName ? this.$route.params.stateName : this.object.shortName;
        },
    },
    methods: {
        // Click event is being sent menually (not from DataLayer.js Mixin)
        sendGaClickEvent(city = null) {
            let position = city ? city.position : this.object.position;
            let name = city ? city.name : this.object.name;
            let products = [
                {
                    name: name,
                    position: position,
                },
            ];
            this.$emit("sendGAClick", { isClicked: true, products });
        },
        showMore() {
            this.$router.push({ path: this.mainActionUrl });
        },
        firstCapital(name) {
            return name.charAt(0).toUpperCase() + name.slice(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.store-locator-card {
    border: none;
    margin-bottom: 30px;
    max-width: 198px;
    .card-img-top {
        width: 100%;
    }
    .card-link-btn {
        color: #4a4a4a;
        width: 100%;
        text-align: left;
        padding: 6px 0;
    }
    .card-link-btn h4 {
        font-size: 1rem;
        padding: 0;
        margin: 0;
    }
    button.show-btn {
        font-family: "Noto Sans KR", sans-serif;
        font-weight: bold;
        border-top: 1px solid #767d985e;
        border-bottom: 1px solid #767d985e;
        border-radius: 0;
        padding: 15px 0;
    }
    .card-title {
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4a4a4a;
        font-family: "Noto Sans KR", sans-serif;
        border-bottom: 1px solid #767d985e;
        padding: 15px 0;
    }
    .title-only {
        border-bottom: none;
        text-align: center;
    }

    .card-headline {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;

        span {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }

    .expand-btn {
        color: #4a4a4a;
        font-size: 18px;
    }
}
</style>
